.list {
  display: grid;
  margin: 0;
  padding: 0;
  list-style: none;
}

.row {
  position: relative;
  background: var(--gg-color-bg-canvas);
}

.row[data-dragging] {
  z-index: var(--gg-z-sticky);
  border-radius: var(--gg-radius-md);
  box-shadow: var(--gg-shadow-lg);
}

.handle {
  display: inline-grid;
  flex: none;
  place-items: center;
  width: var(--gg-size-control-sm);
  height: var(--gg-size-tap-min);
  padding: 0;
  border: 0;
  border-radius: var(--gg-radius-sm);
  background: none;
  color: var(--gg-color-fg-subtle);
  cursor: grab;
  touch-action: none;
}

.handle:active {
  cursor: grabbing;
}

.handle:focus-visible {
  outline: none;
  box-shadow: var(--gg-shadow-focus);
}
